var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
// import Trigger from 'rc-trigger';
import Trigger from '@rc-component/trigger';
import classNames from 'classnames';
const getBuiltInPlacements = (dropdownMatchSelectWidth, popupOverflow) => {
    // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
    const adjustX = typeof dropdownMatchSelectWidth !== 'number' ? 0 : 1;
    const htmlRegion = popupOverflow === 'scroll' ? 'scroll' : 'visible';
    return {
        bottomLeft: {
            points: ['tl', 'bl'],
            offset: [0, 4],
            overflow: {
                adjustX,
                adjustY: 1
            },
            htmlRegion
        },
        bottomRight: {
            points: ['tr', 'br'],
            offset: [0, 4],
            overflow: {
                adjustX,
                adjustY: 1
            },
            htmlRegion
        },
        topLeft: {
            points: ['bl', 'tl'],
            offset: [0, -4],
            overflow: {
                adjustX,
                adjustY: 1
            },
            htmlRegion
        },
        topRight: {
            points: ['br', 'tr'],
            offset: [0, -4],
            overflow: {
                adjustX,
                adjustY: 1
            },
            htmlRegion
        }
    };
};
const SelectTrigger = (props, ref) => {
    const { prefixCls, visible, children, popupElement, multiple, containerWidth, animation, transitionName, dropdownStyle, dropdownClassName, direction = 'ltr', dropdownMatchSelectWidth = true, dropdownRender, dropdownAlign, getPopupContainer, empty, getTriggerDOMNode, placement, popupOverflow } = props, restProps = __rest(props, ["prefixCls", "visible", "children", "popupElement", "multiple", "containerWidth", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "placement", "popupOverflow"]);
    const dropdownPrefixCls = `${prefixCls}-dropdown`;
    let popupNode = popupElement;
    if (dropdownRender) {
        popupNode = dropdownRender(popupElement);
    }
    const builtInPlacements = React.useMemo(() => getBuiltInPlacements(dropdownMatchSelectWidth, popupOverflow), [
        dropdownMatchSelectWidth, popupOverflow
    ]);
    // ===================== Motion ======================
    const mergedTransitionName = animation ? `${dropdownPrefixCls}-${animation}` : transitionName;
    // ======================= Ref =======================
    const popupRef = React.useRef(null);
    React.useImperativeHandle(ref, () => ({
        getPopupElement: () => popupRef.current
    }));
    const popupStyle = Object.assign({ minWidth: containerWidth }, dropdownStyle);
    if (typeof dropdownMatchSelectWidth === 'number') {
        popupStyle.width = dropdownMatchSelectWidth;
    }
    else if (dropdownMatchSelectWidth) {
        popupStyle.width = containerWidth;
    }
    return (<Trigger {...restProps} showAction={[]} hideAction={[]} popupPlacement={placement || (direction === 'rtl' ? 'bottomRight' : 'bottomLeft')} builtinPlacements={builtInPlacements} prefixCls={dropdownPrefixCls} popupTransitionName={mergedTransitionName} popup={<div ref={popupRef}>{popupNode}</div>} popupAlign={dropdownAlign} popupVisible={visible} getPopupContainer={getPopupContainer} popupClassName={classNames(dropdownClassName, {
            [`${dropdownPrefixCls}-empty`]: empty,
            [`${dropdownPrefixCls}-multiple`]: multiple
        })} popupStyle={popupStyle} getTriggerDOMNode={getTriggerDOMNode}>
            {children}
        </Trigger>);
};
const RefSelectTrigger = React.forwardRef(SelectTrigger);
RefSelectTrigger.displayName = 'SelectTrigger';
export default RefSelectTrigger;
